import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=e37122ce&scoped=true&"
import script from "./StatusDropdown.vue?vue&type=script&lang=js&"
export * from "./StatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37122ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e37122ce')) {
      api.createRecord('e37122ce', component.options)
    } else {
      api.reload('e37122ce', component.options)
    }
    module.hot.accept("./StatusDropdown.vue?vue&type=template&id=e37122ce&scoped=true&", function () {
      api.rerender('e37122ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/StatusDropdown.vue"
export default component.exports